var c = (s, r, e) => new Promise((n, t) => {
  var i = (o) => {
    try {
      p(e.next(o));
    } catch (u) {
      t(u);
    }
  }, a = (o) => {
    try {
      p(e.throw(o));
    } catch (u) {
      t(u);
    }
  }, p = (o) => o.done ? n(o.value) : Promise.resolve(o.value).then(i, a);
  p((e = e.apply(s, r)).next());
});
function l(s) {
  if (s == null) return null;
  const r = Array.isArray(s) ? s : s.split(",");
  return new Set(r.map((e) => e.trim()).filter(Boolean));
}
const m = "core";
function d(s, r) {
  return r === null || s === m ? !0 : r.has(s);
}
function h(s) {
  var e;
  const { teacherTotter: r } = s.providers;
  if (r != null && r.enabled && !r.syncUrl)
    throw new Error("[analytics] teacher-totter is enabled but no syncUrl was provided.");
  return {
    app: s.app,
    environment: s.environment,
    providers: s.providers,
    enabledGroups: l(s.enabledFeatureGroups),
    events: s.events,
    debug: (e = s.debug) != null ? e : !1
  };
}
class f {
  constructor(r, e) {
    this.config = r, this.providers = e, this.commonProps = {
      mx_app: r.app,
      mx_env: r.environment,
      mx_locale: "",
      mx_country_code: "",
      mx_user_profile_id: "",
      mx_user_profile_type: "unknown",
      mx_market_region_id: ""
    }, this.runProviders((n) => n.init());
  }
  setCommonProps(r) {
    this.commonProps = {
      mx_app: this.config.app,
      mx_env: this.config.environment,
      mx_locale: r.locale,
      mx_country_code: r.countryCode,
      mx_user_profile_id: r.userProfileId,
      mx_user_profile_type: r.userProfileType,
      mx_market_region_id: r.marketRegionId
    }, this.runProviders((e) => e.setCommonProps(this.commonProps));
  }
  identify() {
    const r = this.commonProps.mx_user_profile_id;
    this.runProviders((e) => e.identify(r, this.commonProps));
  }
  track(r, e) {
    return c(this, null, function* () {
      const n = this.config.events[r];
      if (!n) {
        this.config.debug && console.warn(`[analytics] Unknown event "${r}" not in the event map; skipping.`);
        return;
      }
      const t = {
        name: r,
        group: n.group,
        props: e,
        commonProps: this.commonProps
      };
      yield Promise.all(
        this.providers.map((i) => c(this, null, function* () {
          if (!(i.isGroupGated && !d(t.group, this.config.enabledGroups)))
            try {
              yield i.track(t);
            } catch (a) {
              this.warn(a);
            }
        }))
      );
    });
  }
  trackSession(r) {
    this.runProviders((e) => {
      var n;
      return (n = e.trackSession) == null ? void 0 : n.call(e, r);
    });
  }
  shutdown() {
    this.runProviders((r) => r.shutdown());
  }
  // Analytics must never break a consuming app, so provider failures are isolated and suppressed.
  runProviders(r) {
    this.providers.forEach((e) => {
      try {
        r(e);
      } catch (n) {
        this.warn(n);
      }
    });
  }
  warn(r) {
    this.config.debug && console.warn("[analytics] provider error (suppressed):", r);
  }
}
export {
  f as A,
  d as i,
  l as p,
  h as r
};



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/mx-teacher-analytics/dist/analytics-client-Cj8q1Ezv.js
// module id = 214
// module chunks = 4